/**
 * PATH: packages/email-hub/src/feature/pages/composePreviewState.ts
 * FILE_ID: EMAILHUB-COMPOSE-PREVIEW-STATE-001
 * PURPOSE: Seed the compose reference pane from navigation state.
 * WHY: Compose must open the email that was already selected, and toggling
 *      that preview must not remount the draft. The seed runs once.
 */
import { useState, type Dispatch, type SetStateAction } from 'react'
import { useLocation } from 'react-router-dom'

export function composePreviewEmailId(state: unknown): string | null {
  if (!state || typeof state !== 'object') return null
  const value = (state as { previewEmailId?: unknown }).previewEmailId
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  return trimmed || null
}

export function composePreviewLocationState(
  emailId: string | null | undefined,
): { previewEmailId: string } | undefined {
  const id = typeof emailId === 'string' ? emailId.trim() : ''
  return id ? { previewEmailId: id } : undefined
}

/** First navigation seeds the pane. Later state changes do not reopen a closed preview. */
export function useComposePreviewEmail(): [
  string | null,
  Dispatch<SetStateAction<string | null>>,
] {
  const location = useLocation()
  return useState<string | null>(() => composePreviewEmailId(location.state))
}
